<template>
  <app-filter ref="filter-component">
    <app-input type="text"
               v-model="properties.delegate.search"
               :label="t('app-email')"
               @input="refresh"
    />
    <app-select :label='t("app-account-type")'
                :options="accountTypeOptions"
                v-model="properties.delegate.accountType"
                @input="refresh"
    />
  </app-filter>
</template>

<script lang="ts">
import FilterMixin from "../../../modules/filter/FilterMixin"
import OptionCollection from "Models/OptionCollection"

export default {
  mixins: [FilterMixin],

  data() {
    return {
      accountTypeOptions: (new OptionCollection())
        .add("")
        .add("app-global-administrator")
        .add("app-affiliate-administrator")
        .add("app-organization-administrator")
        .add("app-program-administrator")
        .options
    }
  }
}
</script>
